<template>
    <!-- 联系我们  -->
    <div class="contactus">
        <div class="contact-warp">
            <h2 class="title">联系我们</h2>
            <ul class="basicInfo-list flex-align">
                <li v-for="(item,index) in basicInfo" :key="index" class="basicInfo-item">
                    <div class="icon-warp">
                        <i :class="[item.icon]" class="basic-icon"></i>
                    </div>
                    <p class="basic-name">{{item.name}}</p>
                    <p class="basic-text">{{item.text}}</p>
                </li>
            </ul>
            <img src="../../assets/general/map.png" alt="" class="map">
            <p class="tip">感谢您的关注！如果您有任何想法、意见或建议，请填写如下内容告知我们您的需求，我们将尽快与您联系！</p>
            <div class="form">
                <el-form :inline="true" :model="formInline" label-width="80px" ref="form">
                    <el-form-item label="姓名" prop="name" required class="form-item">
                        <el-input v-model="formInline.name" placeholder="姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="phone" required class="form-item">
                        <el-input v-model="formInline.phone" placeholder="电话"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email" required class="form-item">
                        <el-input v-model="formInline.email" placeholder="邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="地区" prop="area" required class="form-item">
                        <el-input v-model="formInline.area" placeholder="地区"></el-input>
                    </el-form-item>
                    <el-form-item label="单位机构" prop="unit" required class="form-item">
                        <el-input v-model="formInline.unit" placeholder="单位机构"></el-input>
                    </el-form-item>
                    <el-form-item label="问题类型" prop="questType" required class="form-item">
                        <el-select v-model="formInline.questType" placeholder="请选择问题类型">
                            <el-option label="商务合作" value="1"></el-option>
                            <el-option label="售后服务" value="2"></el-option>
                            <el-option label="意见或建议" value="3"></el-option>
                            <el-option label="其他问题" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动形式" prop="textarea" required class="form-textarea">
                        <el-input type="textarea" v-model="formInline.textarea"></el-input>
                    </el-form-item>
                    <el-form-item class="submit-item">
                        <el-button type="primary" @click="submitForm('numberValidateForm')">提交</el-button>
                        <el-button @click="resetForm('form')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                basicInfo: [{
                        icon: 'el-icon-location-outline',
                        name: '办公地址',
                        text: '北京市海淀区西三环北路105号院'
                    },
                    {
                        icon: 'el-icon-phone-outline',
                        name: '电话',
                        text: '010-88512948'
                    },
                    {
                        icon: 'el-icon-message',
                        name: '电子邮箱',
                        text: 'yd@lezhireading.com'
                    }, {
                        icon: 'el-icon-postcard',
                        name: '邮编',
                        text: '100071'
                    }
                ],
                formInline: {
                    name: '',
                    phone: '',
                    email: '',
                    area: '',
                    questType: undefined,
                    textarea: '',
                }
            }
        },
        methods: {
            submitForm() {},
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },
    }
</script>

<style lang="less" scoped>
    .contact-warp {
        padding: 0 5.2%;

        .title {
            font-size: 26px;
            padding: 3.3% 0 4.1%;
            text-align: center;
        }

        .basicInfo-item {
            width: calc(100% / 4);
            text-align: center;
            font-size: 16px;

            .icon-warp {
                display: inline-block;
                background-color: #2986DC;
                padding: 15px;
                border-radius: 50%;
                margin-bottom: 35px;
            }

            .basic-icon {
                font-size: 50px;
                color: #fff;
            }

            &:nth-child(2) .icon-warp {
                background-color: #FE9437;
            }

            &:nth-child(3) .icon-warp {
                background-color: #A782D9;
            }

            &:nth-child(4) .icon-warp {
                background-color: #2986DC;
            }


            .basic-name {
                margin-bottom: 15px;
            }

        }


        .map {
            display: block;
            margin: 5% auto;
            width: 100%;
        }

        .tip {
            padding: 0 6%;
            font-size: 25px;
            line-height: 2;
        }

        .form {
            padding: 0 6%;
            margin-top: 5%;

            .form-item {
                width: 48%;

                /deep/.el-form-item__content {
                    width: 70%;
                }
            }

            .form-textarea {
                width: 100%;

                /deep/ .el-form-item__content {
                    width: 82.5%;
                }

                /deep/ .el-textarea__inner {
                    resize: none;
                    width: 100%;
                    height: 200px;
                }
            }

            .submit-item {
                display: block;
                text-align: center;
            }
        }


        @media screen and (min-width:1250px) {
            .title {
                font-size: 36px;
            }

            .basicInfo-item {
                font-size: 22px;

                .icon-warp {
                    padding: 25px;
                    margin-bottom: 35px;
                }

                .basic-icon {
                    font-size: 70px;
                }

                .basic-name {
                    margin-bottom: 20px;
                }

            }

            .map {
               width: auto;
            }

        }


    }
</style>